import {
    AssetGroup,
    AssetGroupAssociationData,
    AssetGroupUpdateData,
} from '@app/shared/models/asset-group.model';
import { HttpClient } from '@angular/common/http';
import { AssetGroupAssociation } from '@core/utils/asset-group/asset-group-association';

export class UpdateAGAssociation extends AssetGroupAssociation {
    action = 'PUT';
    data: AssetGroupUpdateData;

    constructor(
        httpClient: HttpClient,
        assetGroup: AssetGroup,
        originalList: AssetGroup[],
        updatedList: AssetGroup[]
    ) {
        super(httpClient);
        this.data = this.getData(assetGroup, originalList, updatedList);
    }

    getAssociationPayload(): AssetGroupAssociationData {
        return {
            refAssetGroup: this.data.assetGroup.original.id,
            action: this.action,
            lineageFrom: [
                ...super.getAncestorsIds(
                    this.data.assetGroup.original,
                    this.data.hierarchy.original,
                    []
                ),
                this.data.assetGroup.original.id,
                ...super.getChildrenIds(
                    this.data.assetGroup.original,
                    this.data.hierarchy.original,
                    []
                ),
            ],
            lineageTo: [
                ...super.getAncestorsIds(
                    this.data.assetGroup.updated,
                    this.data.hierarchy.updated,
                    []
                ),
                this.data.assetGroup.updated.id,
                ...super.getChildrenIds(
                    this.data.assetGroup.updated,
                    this.data.hierarchy.updated,
                    []
                ),
            ],
        };
    }
}
